<template lang="pug">
	footer#footer
		.siteMap(v-if="menu")
			.wrapper
				nav(:class="`menu-${key}` | slugify", v-for="items, key in menu")
					h4 {{ key }}
					ul
						li(v-for="item in items")
							a(:href="item.link | validateURL", :target="item.new_page ? '_blank' : ''", :title="item.nome") {{ item.nome }}
		.siteMap.loading(v-else)
			.wrapper
				nav(v-for="i in 5")
					h4
					ul
						li(v-for="i in 3")

		.linksUteis
			.wrapper
				.box
					router-link(:to="{ name:'home' }")
						h1
							| Centro Universitário UNIFAEL
							//- include ../../assets/images/icones/icone-fael.svg
							img(:src="require(`@images/icones/logo-footer.png`)")
					ul.redes
						li
							a(:href="$utils.redes.facebook", title="Facebook", target="_blank")
								include ../../assets/images/icones/icone-facebook.svg
						li
							a(:href="$utils.redes.instagram", title="Instagram", target="_blank")
								include ../../assets/images/icones/icone-instagram.svg
						li
							a(:href="$utils.redes.linkedin", title="Linkedin", target="_blank")
								include ../../assets/images/icones/icone-linkedin.svg
				.box
					.emec
						h2 Consulte aqui o cadastro da Instituição no e-MEC
						.qrcode
							picture.logo
								img(src="@images/e-mec/logo-e-mec.png", alt="e-MEC")
							picture.qr
								img(src="@images/e-mec/QRCodeUnifael.png", alt="alt")
							a(href="https://emec.mec.gov.br/emec/consulta-cadastro/detalhamento/d96957f455f6405d14c6542552b0f6eb/MTIwNQ==", target="_blank", title="Consulte aqui o cadastro da Instituição no e-MEC") ACESSE JÁ!
		.selos
			.wrapper
				ul
					li(v-for="selo in selos")
						img(:src="selo")

</template>

<script>
export default {
	name: "component-footer",
	filters: {
		validateURL(valor) {
			if (valor.includes('http'))
				return valor
			return valor[0] == '/' ? valor : '/' + valor
		}
	},
	data() {
		return {
			selos: [
				require(`@images/selos/mec-conceito4.png`),
				require(`@images/selos/indicado_epocaNegocios-v2.png`),
				require(`@images/selos/abmes-03.png`),
				require(`@images/selos/abmes-01-v2.png`),
				require(`@images/selos/abmes-02.png`),
				require(`@images/selos/ias-200x200.png`),
				require(`@images/selos/selo-gptw.png`),
				require(`@images/selos/melhores_gptw.png`),
			],
			menu: null
		}
	},
	created() {
		this.loadMenu()
	},
	methods: {
		loadMenu() {
			this.$axios
				.get(`menu/footer`)
				.then(response => this.menu = response.data)
		}
	},
}
</script>

<style lang="stylus" scoped src="./Footer.styl"></style>
